import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlLocation,
  urlLocationSecured,
  urlGetAllLocationSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_LOCATION,
  GET_LOCATION,
  UPDATE_LOCATION,
  DELETE_LOCATION,
  FILTER_LOCATION,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
    if (filters.viveroUuid !== undefined)
      filter += "&viveroUuid=" + filters.viveroUuid;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

const generateFilterQueryAll = ({ filters }) => {
  let filter = "?";

  if (filters) {
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
    if (filters.viveroUuid !== undefined)
      filter += "&viveroUuid=" + filters.viveroUuid;
  }

  return filter;
};

/**
 * Get Location by uuid.
 */
export const getLocationByUuid = createAction(GET_LOCATION, (param) =>
  apiGet(urlLocationSecured, param, true)()
);

/**
 * Filter list Location.
 */
export const filterLocation = createAction(FILTER_LOCATION, (filter, param) =>
  apiGet(urlLocationSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Location.
 */
export const createLocation = createAction(CREATE_LOCATION, (obj) =>
  apiPost(urlLocationSecured, obj, undefined, true)()
);

/**
 * Update Location.
 */
export const modifyLocation = createAction(UPDATE_LOCATION, (obj, param) =>
  apiPut(urlLocationSecured, obj, param, true)()
);

/**
 * Delete Location by uuid.
 */
export const removeLocation = createAction(DELETE_LOCATION, (param) =>
  apiDelete(urlLocationSecured, param, true)()
);

/**
 * Filter list locations.
 */
export const getAll = createAction("GET_ALL_LOCATIONS", (filters) =>
  apiGet(
    urlGetAllLocationSecured + generateFilterQueryAll(filters),
    undefined,
    false
  )()
);
